var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},[_c('BobDisplayForm',{attrs:{"config":{
      rowGap: 12,
      labelWidth: '150px',
    },"fields":_vm.displayFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }